import React, {useEffect, useState} from "react";
import apiClient from "../axios/axiosInterceptor";
import UserSearch from "./UserSearch";
import UsersTable from "./UsersTable";
import '../modal.scss';
import UserCreate from "./UserCreate";
import {Slide, toast} from "react-toastify";

function Users({loggedInUser}) {
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingUser, setEditingUser] = useState(null);

    const fetchUsers = async (params) => {
        const baseUrl = `/tenants/${loggedInUser.TenantId}/users`;
        const queryParams = new URLSearchParams(params);

        try {
            const response = await apiClient.get(baseUrl, {
                params: queryParams,
            });
            setUsers(response.data.list);
        } catch (error) {
            // Handle error appropriately
            console.error('Error fetching users:', error);
        }
    }

    useEffect(() => {
        fetchUsers({userStatus: 1});
    }, []);

    const search = async (username, userStatus) => {
        const newSearchParams = {username, userStatus};
        await fetchUsers(newSearchParams);
    };

    const handleCreate = () => {
        setEditingUser(null);
        setShowModal(true);
    };

    const handleEdit = (user) => {
        setEditingUser(user);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        const url = `/tenants/${loggedInUser.TenantId}/users/${id}`;

        try {
            await apiClient.delete(url);
            await fetchUsers({userStatus: 1});
        } catch (error) {
            console.error('Error creating user:', error);
        }
    };

    const handleActivate = async (id) => {
        const url = `/tenants/${loggedInUser.TenantId}/users/${id}/activate`;
        try {
            await apiClient.patch(url);
            await fetchUsers({userStatus: 1});
        } catch (error) {
            console.error('Error creating user:', error);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmitModal = async (userData) => {
        const url = editingUser ?
            `/tenants/${loggedInUser.TenantId}/users/${editingUser.id}` :
            `/tenants/${loggedInUser.TenantId}/users`;

        try {
            if (editingUser) {
                await apiClient.patch(url, userData);
                toast.success('User updated!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            } else {
                await apiClient.post(url, userData);
                toast.success('User created!', {
                    position: "top-right",
                    autoClose: 3000,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            }
            setShowModal(false);
            await fetchUsers({userStatus: 1});
        } catch (error) {
            console.error('Error creating user:', error);
        }
    };

    return (
        <div className="mainBody">
            <UserSearch onSearch={search} onCreate={handleCreate}/>
            <UsersTable users={users} onEdit={handleEdit} onDelete={handleDelete} onReactivate={handleActivate}/>
            {showModal && <UserCreate loggedInUser={loggedInUser} user={editingUser} onClose={handleCloseModal}
                                      onSubmit={handleSubmitModal}/>}
        </div>
    );
}

export default Users;
